import { render, staticRenderFns } from "./useraccount.vue?vue&type=template&id=6042c14e&scoped=true"
import script from "./useraccount.vue?vue&type=script&lang=js"
export * from "./useraccount.vue?vue&type=script&lang=js"
import style0 from "./useraccount.vue?vue&type=style&index=0&id=6042c14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042c14e",
  null
  
)

export default component.exports